export default __webpack_public_path__ + "static/img4h-96c80addc07e6991b9a36fe21bc4ffa1.jpg";